const englishTranslations = {
    common: {
        amount: 'Amount',
        accountEndingIn: 'Account ending in {{last4digits}}',
        back: 'Back',
        cancel: 'Cancel',
        close: 'Close',
        date: 'Date',
        description: 'Description',
        done: 'Done',
        lostOrStolen: 'Report Card Lost or Stolen',
        next: 'Next',
        onlineChat: 'Online Chat',
        purchase: 'Purchase',
        replaceYourCard: 'Replace Your Card',
        selectAll: 'Select all',
        submit: 'Submit',
        unselectAll: 'Unselect all'
    },
    cantProcess: {
        cantProcessOnline: "We can't process your request online",
        forAssistance: ' for assistance.',
        pleaseReachOut: 'Please reach out to us via '
    },
    closeConfirmation: {
        closingWillCancel: 'Closing will cancel the request. Do you wish to proceed?',
        noDontCancel: "No, Don't Cancel",
        yesCancelRequest: 'Yes, Cancel Request',
        yourProgressWillNot: 'Your progress will not be saved.'
    },
    exitConfirmation: {
        changeAddress: 'Change Address',
        changingYourAddress: 'Changing your address will require additional verification, and we request you to contact us at ',
        exitingWillCancel: 'Exiting will cancel your request',
        goBack: 'Go Back'
    },
    whenLost: {
        cardStolenTitle: 'When was your card stolen?',
        dateCannotBeBeforeMinimum: 'The date cannot be before January 1, 1970',
        dateMustBeValid: 'Date must be a valid calendar date MM/DD/YYYY',
        dontKnow: "I don't know the date",
        futureDate: 'Date must be on or before today',
        lostCardTitle: 'When was your card lost?',
        pleaseSelect: 'Please select a date to continue'
    },
    reasonSelection: {
        damagedCardHeading: 'Damaged Card',
        damagedCardBody: 'You’ll receive a replacement card with the same account number, so you can continue using the account until the replacement arrives.',
        ifYouCantFind: "If you can't find your card,",
        makeASelection: 'Please make a selection.',
        neverReceivedCard: 'Never received Card',
        pleaseTellUsMore: 'Please tell us more about your situation',
        reportIt: 'report it lost or stolen',
        yourPreviouslyIssuedCard: 'Your previously issued card will be canceled and you’ll receive a replacement card with a new account number.'
    },
    selectAccount: {
        beforeMaking: ' before making another request.',
        businessDays: ' 7-10 business days ',
        cardOnTheWay: 'A replacement card is on the way. Please allow ',
        selectOneOrMore: 'Please select one or more cardholders.',
        whichCardholder: 'Which cardholder on your account needs a new card?'
    },
    selectCardholder: {
        contactUs: 'Contact us using ',
        toCommunicate: '.',
        eligibleCardholders: 'Eligible cardholders are shown below. Missing a cardholder?',
        selectOne: 'Please select a cardholder.'
    },
    recognizeTransaction: {
        previousCardActivated: 'Your previously issued card was sent pre-activated, so we want to ensure there were no fraudulent charges.',
        doYouRecognize: 'Do you recognize all these transactions?',
        yesRecognize: 'YES I RECOGNIZE',
        noDontRecognize: "NO I DON'T RECOGNIZE"
    },
    errorBoundary: {
        title: "We're having trouble loading this page",
        pleaseTryAgain: 'Please try again later or reach out to us via '
    },
    cantVerify: {
        address: 'Address',
        forAssistance: ' for assistance.',
        havingTroubleVerify: "We're having trouble verifying your identity",
        noDontRecognize: "NO I DON'T RECOGNIZE",
        noTransactionsFound: 'No transactions found',
        pleaseReachOut: 'Please reach out to us via ',
        purchaseLocation: 'Purchase Location',
        purchase: 'Purchase',
        referenceNumber: 'Reference Number',
        refund: 'Refund',
        yesRecognize: 'YES I RECOGNIZE'
    },
    unableSubmit: {
        weAreUnable: "We're unable to submit your request",
        pleaseContact: 'Please contact us immediately via '
    },
    summaryDetails: {
        addToYourDigital: 'Add to your digital wallet',
        allowUp: 'Allow up to 7 days',
        beforeSubmitting: ' before submitting your request.',
        cardholderRequestFailed: "Your request for the cardholder below didn't go through - please try again ",
        deliveryDetails: 'Delivery Details',
        deliveryMethod: 'Delivery Method',
        expectedDelivery: 'Expected delivery 7 - 10 business days',
        forYourAccount: ' for your account to reflect these new details.',
        freeShipping: 'Free shipping',
        itCanTake: '. It can take up to 2 business days for tracking updates to appear.',
        manageProfile: 'Manage Profile',
        needMoreHelp: 'Need more help? Contact us using ',
        note: 'Paperless statements, payment methods, scheduled payments and Autopay will not be affected.',
        noteTitle: 'Note: ',
        noteWithUpdate: "Paperless statements, payment methods, scheduled payments and Autopay will not be affected. You'll need to update your card information with any companies or services that automatically bill you.",
        onceYouSubmit: 'Once you submit this request it can’t be reversed. You can continue using your account until the new card arrives.',
        onceYouSubmit7days: 'Once you submit this request it can’t be reversed. Cards for the users below will no longer work and will be reissued with a new account number. ',
        onceYouSubmitMisplaced: 'Once you submit this request it can’t be reversed. You will receive a replacement card with the same account number. If you find your misplaced card, you may continue using it until you activate your new card.',
        onlineChat: 'Online Chat',
        payEasily: 'PAY EASILY: ANYWHERE, ANYTIME.',
        pleaseReview: 'Please review the following information carefully before submitting',
        requestDetails: 'Request Details',
        secureWay: ' for a secure and convenient way to pay.',
        shippingAddress: 'Shipping Address',
        standardDelivery: 'Standard delivery by USPS',
        theFollowingCardholders: 'The following cardholders on your {{accountName}} account will be issued a new card:',
        toCommunicateWithUs: '.',
        trackYourCard: 'Track your card',
        wellNotifyYou: "We'll notify you when your card ships - you can keep using your account until the new card arrives. We've sent a confirmation email to {{email}}.",
        wrongAddress: 'Wrong address? Update it in ',
        yourReplacementWillBe: 'Your replacement card will be sent to the current mailing address on your profile:',
        shippedNotify: "We'll notify you when your card ships - you can keep using your account until the new card arrives. We've sent a confirmation email to {{ variables.email }}",
        yourReplacementHasBeen: 'Your replacement card has been ordered and should arrive within 7-10 business days',
        toCheckYourCard: 'To check your card shipping status, visit '
    },
    reasonSelectionLostStolen: {
        cardDamaged: 'If your card is damaged, you can ',
        freezeAccount: 'Freeze Account',
        lostCardHeading: 'Lost Card',
        lostCardBody: "Your card will be canceled and you'll receive a replacement card with a new account number.",
        misplacedCardHeading: 'Misplaced Card in Home',
        misplacedCardBody: "You'll receive a replacement card with the same account number. If you are worried your account number may have been compromised, please select 'Lost Card' so a new account number will be issued.",
        needTime: "Need time to look for your card? We'll decline new purchases until you unfreeze your account.",
        requestReplacement: 'request a replacement',
        stolenCardHeading: 'Stolen Card',
        stolenCardBody: "Your card will be canceled and you'll receive a replacement card with a new account number."
    },
    tempBlock: {
        yourAccount: 'Your account is temporarily locked',
        forYourProtection: 'For your protection, please contact us at ',
        soWeCanReview: " so we can review your recent activity. If we detect fraud, we'll open a claim and send you a new card.",
        fraudPrevention: 'Fraud Prevention Tips and FAQs',
        fraudLiabilityBold: '$0 Fraud Liability',
        fraudLiability: "You're never responsible for unauthorized charges"
    }
};
export default englishTranslations;
//# sourceMappingURL=en.js.map